var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"qrcode",staticClass:"qr-code"})])
}
var staticRenderFns = []

export { render, staticRenderFns }